<template>
  <div class="adv-listing-filters-clear">
    <a :href="getUrlNoFilters" class="adv-listing-filters-clear-btn"><img src="/ui/main/img/delete.svg" alt="Διαγραφή"> <span>{{ t('filters.clear.all') }}</span></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedFiltersClear',
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ])
  }
}
</script>

<style lang="scss" scoped>
.adv-listing-filters-clear {
  position: relative;
  display: grid;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: end;
  &-btn {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 13px;
    line-height: 1.2;
    color: black;
    span{
      margin-left: 5px;
    }
  }
  @media screen and (max-width: 992px) {
    display: none;
  }
}
</style>
